import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useQueryParams from "../utils/query.params";
import LoggerService from "../services/logger.service";
import RespondentFlowApi from "../services/respondentFlow.api";
import UILoggerService from "../services/ui.logger.service";
import ClipLoader from "react-spinners/ClipLoader";
import Error from "./Error";
import { windowLocation, windowLocationRelayed } from "../services/redirection.service";

const Landing = () => {
  const [Loader] = useState(true);
  const [ErrorMessage, setErrorMessage] = useState("Loading");
  const [paramActive, setParamActive] = useState(false);
  const [params, setParams] = useState({});

  // const queryParams = useQueryParams(); // ✅ Hook called at the top
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const temp = {};
  
    for (const [key, value] of searchParams.entries()) {
      temp[key] = value;
    }
  
    setParams(temp);
}, []);

  let navigate = useNavigate();

  useEffect(() => {
    if (Object.keys(params).length > 0) {
      try {
        params["url"] = window.location.href;
        if (params["eid"] || params["tk"]) {
          LoggerService.log(
            params["eid"],
            "",
            "Redirect received on end page" + window.location.href
          );
        }
        RespondentFlowApi.post("/v1/ending/", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then(async (data) => {
            if (data.result === "not_ok") {
              navigate(`/error?token=${params["eid"] ?? params["tk"]}`);
              return;
            } else if (data.hasError) {
              LoggerService.log(
                params["eid"] ?? params["tk"],
                "",
                "Error on end page",
                data.messages[0]
              );
              setErrorMessage(data.messages[0]);
              return;
            } else {
              if (data.isInternalRedirect) {
                LoggerService.log(
                  params["eid"],
                  "",
                  "New survey routing recieved for survey " + data.surveyUid,
                  JSON.stringify(data)
                );
                let obj = {};
                obj.traceId = data.traceId;
                obj.paramList = data.paramList;
                obj.sessionUid = data.sessionUid;
                obj.surveyUid = data.surveyUid;
                obj.vendorUid = data.vendorUid;
                obj.token = data.token;
                obj.tokenId = data.tokenId;
                obj.userUid = data.userUid;
                obj.userId = data.userId;
                sessionStorage.removeItem("params");
                sessionStorage.setItem("params", JSON.stringify(obj));
                navigate(`/screener?token=${obj.token}`);
              } else {
                sessionStorage.removeItem("params");
                LoggerService.log(
                  params["eid"],
                  "",
                  "Final redirect " + `${data.redirectUrl}`,
                  JSON.stringify(data.data)
                )
                  .then(() => {
                    windowLocationRelayed(data.redirectUrl,params["eid"] ?? params["tk"])
                  })
                  .catch(() => {
                    windowLocation(data.redirectUrl);
                  });
              }
            }
          })
          .catch((e) => {
            console.error(e);
            UILoggerService.sendLog(
              window.location.href,
              "EndingAPIResp Error",
              e
            )
              .then(() => {
                navigate(`/error`);
              })
              .catch(() => {
                navigate(`/error`);
              });
          });
      } catch (err) {
        UILoggerService.sendLog(
          window.location.href,
          "EndingAPIResp Error",
          err
        )
          .then(() => {
            navigate(`/error`);
          })
          .catch(() => {
            navigate(`/error`);
          });
      }
    }
    // eslint-disable-next-line
  }, [params]);

  return (
    <>
      {Loader ? (
        ErrorMessage === "Loading" ? (
          <div className="flex flex-col items-center justify-center h-screen bg-gray-200">
            <ClipLoader color="rgb(129, 176, 60)" loading={true} size={80} />
          </div>
        ) : (
          <Error ErrorMessage={ErrorMessage} />
        )
      ) : (
        <>
          <div className="flex  justify-center">
            <img
              src="https://img.icons8.com/bubbles/256/man-with-a-clock.png"
              alt=""
            />
          </div>
        </>
      )}
    </>
  );
};

export default Landing;
